<template>
  <v-dialog
    :value="value"
    @input="sendInput"
    transition="dialog-top-transition"
    max-width="400"
  >
    <v-toolbar color="primary" dense dark>
      <v-toolbar-title>Пользователь ЛК</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-card>
      <v-card-text>
        <v-container>
          <div class="d-flex align-start black--text text-h6">{{user ? user.EMP_LAST_NAME : ''}} {{user ? user.EMP_NAME : ''}} {{user ? user.EMP_SNAME : ''}}</div>
          <div class="d-flex align-end"><v-spacer></v-spacer><small>{{user ? user.ITP_MNEMO : ''}}</small></div>
          <div class="d-flex align-start black--text">
            <v-switch
              v-model="isActive"
              :label="lockLabel"
              :disabled="switchIsLocked"
              hint="Состояние блокировки"
              persistent-hint
              color="success"
              dense
            ></v-switch>
          </div>
          <v-divider></v-divider>
          <v-row class="mt-5">
            <v-col cols="12">
              <v-autocomplete
                v-model="userDept"
                :items="orgWAList"
                item-text="DEPT_NAME"
                item-value="DEPT_ID"
                label="Роль пользователя ЛК*"
                :disabled="roleIsLocked"
                required dense
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="mode == 'create'">
              <v-text-field
                v-model="login"
                label="Системное имя*"
                hint="Только латинские символы и цифры, первый символ не может быть цифрой, спецсимволы не разрешены"
                @keypress="checkCharcode"
                required dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <small>*Поля, обязательные для заполнения</small>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click="onCloseEvent()"
        >
          Закрыть
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="onSaveEvent"
          :disabled="!isFormValid"
          v-if="mode == 'create'"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ORG_SET_PO_USER, ORG_LOCK_PO_USER, ORG_UPD_USER_ROLE } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
  },
  data: () => ({
    DEPT_ID: null,
    login: ''
  }),
  computed: {
    mode: {
      get: function () {
        if (!this.user) { return undefined }
        if (Number(this.user.USR_ID) > 0) { return 'edit' }
        return 'create'
      }
    },
    switchIsLocked: {
      get: function () {
        if (!this.user) { return true }
        if (this.user.IS_ACTIVE_USR === '-5') { return true }
        return Number(this.user.IS_REAL) === -3
      }
    },
    roleIsLocked: {
      get: function () {
        if (!this.user) { return true }
        return Number(this.user.IS_REAL) === -3
      }
    },
    isActive: {
      get: function () {
        if (!this.user) { return false }
        if (this.user.IS_ACTIVE_USR === null) { return false }
        return Number(this.user.IS_ACTIVE_USR) === 0
      },
      set: function (val) {
        const payload = {
          EMP_ID: this.user.EMP_ID,
          USR_ID: this.user.USR_ID,
          LOGNAME: this.user.LOGNAME,
          INST_UUID: this.user.INST_UUID
        }
        val ? payload.IS_STATE = 0 : payload.IS_STATE = -3
        this.$store.dispatch(ORG_LOCK_PO_USER, payload)
          .then((resp) => {
            val ? this.$emit('onUserUnlocked', resp) : this.$emit('onUserLocked', resp)
            this.$store.commit(UI_SNACKBAR, { color: 'green accent-4', text: val ? 'Блокировка снята' : 'Блокировка установлена' })
          })
          .catch((err) => {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка активации пользователя' + err })
            console.log('Ошибка ', err)
          })
      }
    },
    lockLabel: {
      get: function () {
        if (!this.user) { return '' }
        if (Number(this.user.IS_ACTIVE_USR) < -3) { return 'Не определено' }
        if (this.user.IS_ACTIVE_USR === null) { return 'Не определено' }
        if (Number(this.user.IS_ACTIVE_USR) === -3) { return 'Блокирован' }
        return 'Активен'
      }
    },
    orgWAList: {
      get: function () {
        return this.$store.getters.getOrgDepts
      }
    },
    userDept: {
      get: function () {
        if (!this.user) { return '' }
        if (this.mode === 'create') {
          return this.DEPT_ID
        } else {
          return this.user.DEPT_ID
        }
      },
      set: function (val) {
        if (this.mode === 'create') {
          this.DEPT_ID = val
          return
        }
        const payload = {
          EMP_ID: this.user.EMP_ID,
          USR_ID: this.user.EMP_ID,
          DEPT_ID: val,
          INST_UUID: this.user.INST_UUID
        }
        this.$store.dispatch(ORG_UPD_USER_ROLE, payload)
          .then((resp) => {
            this.$emit('onUserRoleChanged', resp)
          })
          .catch((err) => {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка смены роли пользователя' + err })
            console.log('Ошибка ', err)
          })
      }
    },
    isFormValid: {
      get: function () {
        const result = (String(this.login).length > 6) && (this.DEPT_ID)
        return result
      }
    },
    currDivisionID: {
      get: function () {
        return this.user.ITP_ID
      }
    }
  },
  methods: {
    sendInput (val) {
      this.$emit('input', val)
    },
    clearForm () {
      this.DEPT_ID = null
      this.login = ''
    },
    onCloseEvent (data) {
      this.clearForm()
      this.$emit('input', false)
    },
    onSaveEvent () {
      // Сохраняем данные
      const user = {
        firstname: this.user.EMP_NAME,
        lastname: this.user.EMP_LAST_NAME,
        surname: this.user.EMP_SNAME,
        login: this.login,
        DEPT_ID: this.userDept,
        EMP_ID: this.user.EMP_ID,
        INST_UUID: this.user.INST_UUID
      }
      console.log('Saving user: ', user)
      this.$store.dispatch(ORG_SET_PO_USER, user)
        .then((resp) => {
          this.$emit('onUserCreate', resp)
          this.onCloseEvent()
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка создания пользователя' + err })
          console.log('Ошибка ', err)
        })
    },
    checkCharcode (event) {
      const res = /^[a-zA-Z0-9]/.test(String.fromCharCode(event.charCode))
      if (!res) { event.preventDefault() }
    }
  }

}
</script>
